import { SET_PURCHASES } from '../constants/purchases';
import cartAPI from '../../_api/cart';
import { EDUCATION_TYPE_SLUG } from '../../config';


const setPurchases = list => ({type: SET_PURCHASES, list});

export const getPurchases = (type) => async (dispatch) => {
  let response;
  if (type) response = await cartAPI.getPurchases(type);
  else {
    response = await cartAPI.getPurchases(type);
    const education_response = await cartAPI.getPurchases(EDUCATION_TYPE_SLUG);

    if (!response) response = education_response;
    else if (response && education_response) response = response.concat(education_response)

    // записываем в id дата, для сортировки
    if (response) response = response.map(i => ({...i, id: new Date(i.date_created)}));
  }
  if (response) dispatch(setPurchases(response));
};

